// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mnbl","type":"styles_type__3G-U5","choices":"styles_choices__1JrhT"};